<template>
  <div class="about">
    <h1>The events site for a better world</h1>
  </div>
</template>
